module.exports = __webpack_public_path__ + "img/EME_titlelogo_TW.c3eb9d2a.png";